import { useState, useEffect, useCallback } from 'react';

/**
 * Captura o evento beforeinstallprompt para oferecer um botão "Instalar" nativo.
 *
 * Só o Chrome/Edge (Android e desktop) disparam esse evento. iOS Safari NÃO o
 * expõe — lá a instalação do PWA é manual (Compartilhar > Adicionar à Tela de
 * Início), então nesse caso o hook devolve {podeInstalar:false} e o modal mostra
 * as instruções em vez do botão.
 *
 * O navegador dispara o evento uma única vez e cedo; por isso escutamos no nível
 * do módulo e guardamos o último prompt, para um componente montado depois (o
 * modal, que só aparece após o login) ainda conseguir usá-lo.
 */
let promptGuardado = null;

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault(); // impede o mini-infobar automático; disparamos no clique
    promptGuardado = e;
    window.dispatchEvent(new Event('pwa-instalavel'));
  });
  window.addEventListener('appinstalled', () => {
    promptGuardado = null;
  });
}

export default function useInstalarPWA() {
  const [podeInstalar, setPodeInstalar] = useState(!!promptGuardado);

  useEffect(() => {
    const onDisponivel = () => setPodeInstalar(true);
    const onInstalado = () => setPodeInstalar(false);
    window.addEventListener('pwa-instalavel', onDisponivel);
    window.addEventListener('appinstalled', onInstalado);
    return () => {
      window.removeEventListener('pwa-instalavel', onDisponivel);
      window.removeEventListener('appinstalled', onInstalado);
    };
  }, []);

  /** Abre o prompt nativo de instalação. Devolve true se o usuário aceitou. */
  const instalar = useCallback(async () => {
    if (!promptGuardado) return false;
    promptGuardado.prompt();
    const { outcome } = await promptGuardado.userChoice;
    promptGuardado = null;
    setPodeInstalar(false);
    return outcome === 'accepted';
  }, []);

  return { podeInstalar, instalar };
}
